module.exports = __webpack_public_path__ + "snowball.7ab9a491.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/snowball.svg
// module id = xhNF
// module chunks = 0